import { useMapContext } from '@components/map/MapContext';
import { useWithDispatch } from '@hooks/useWithDispatch';
import {
  closePopupByMapIdAndType,
  switchDrawModeByMapId,
  updateDrawPolygonsData,
  updateDrawZoneTypeSelected,
  updatePopupByMapId,
} from '@redux/maps/maps.reducer';
import {
  selectMapDrawPolygonsPoints,
  selectMapDrawZoneType,
  selectMapEditPolygonsInfo,
  selectPopupsByMapId,
} from '@redux/maps/maps.selectors';
import { isOpenedPopupByType } from '@utils/popup.utils';
import { useCallback, useEffect } from 'react';

import { PopupTypeEnum } from '@/types/popup.types';

import { useSelectorWithMapId } from './useSelectorWithMapId';

export const useZoneFormPopup = () => {
  const { mapId } = useMapContext();

  const drawnPoints = useSelectorWithMapId(selectMapDrawPolygonsPoints);
  const editedZone = useSelectorWithMapId(selectMapEditPolygonsInfo);
  const zoneType = useSelectorWithMapId(selectMapDrawZoneType);
  const popups = useSelectorWithMapId(selectPopupsByMapId);

  const updatePopup = useWithDispatch(updatePopupByMapId);
  const closePopup = useWithDispatch(closePopupByMapIdAndType);

  const dispatchSwitchDrawModeByMapId = useWithDispatch(switchDrawModeByMapId);
  const dispatchUpdateDrawPolygonsData = useWithDispatch(updateDrawPolygonsData);
  const dispatchZoneType = useWithDispatch(updateDrawZoneTypeSelected);

  const openedZoneForm = isOpenedPopupByType(popups, PopupTypeEnum.ZONE);

  const handleDrawnZoneFormClose = useCallback(() => {
    closePopup({ mapId, type: PopupTypeEnum.ZONE });

    dispatchSwitchDrawModeByMapId({ mapId, isDrawable: false });
    dispatchUpdateDrawPolygonsData({ mapId, points: { type: 'Polygon', coordinates: [[]] } });
    dispatchZoneType({ mapId, zoneType: undefined });
  }, [closePopup, dispatchSwitchDrawModeByMapId, dispatchUpdateDrawPolygonsData, dispatchZoneType, mapId]);

  useEffect(() => {
    if (drawnPoints && (drawnPoints.coordinates[0].length > 3 || editedZone) && !openedZoneForm) {
      updatePopup({
        mapId,
        popup: {
          type: PopupTypeEnum.ZONE,
          position: { x: 400, y: 400 },
          data: {
            points: drawnPoints,
            editedZone,
            zoneType,
          },
        },
      });
    } else if (openedZoneForm && (!drawnPoints || !(drawnPoints.coordinates[0].length > 3 || editedZone))) {
      handleDrawnZoneFormClose();
    }
  }, [drawnPoints, editedZone, handleDrawnZoneFormClose, mapId, openedZoneForm, popups, updatePopup, zoneType]);
};
